export default __webpack_public_path__ + "static/Steven Amadeus-cdd658d0efafcc82c7ce03f86c74b53c.webp";